// Import base components
import { httpAI, httpV2 } from "../http.js";

const ReportsService = {
  getOverviews: (startDate, endDate, page) =>
    httpV2.get("/reports/overviews", {
      params: {
        start_date: startDate,
        end_date: endDate,
        page,
      },
    }),

  getGuestBooks: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/guestbooks", {
      params: {
        start_date,
        end_date,
        filter,
        page,
        per,
      },
    }),

  getGuestBooksByDevice: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/guestbooks_by_device", {
      params: {
        start_date,
        end_date,
        filter,
        page,
        per,
      },
    }),

  getGuestBooksByGuest: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/guestbooks_by_guest", {
      params: {
        start_date,
        end_date,
        filter,
        page,
        per,
      },
    }),

  getFiveStar: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/fivestar", {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getSurveyReport: (survey_id, start_date, end_date) =>
    httpV2.get(`/reports/survey_reports/${survey_id}`, {
      params: {
        start_date,
        end_date,
      },
    }),

  getExtendStay: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/extendstay", {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getGuestChecks: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/guestcheck", {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getExtendStayChecks: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/extendstayCheck", {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getWebChat: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/webchat", {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getChatbotLogs: (start_date, end_date, page, per) =>
    httpAI.get("/logs/report", {
      params: {
        start_date,
        end_date,
        page,
        per,
      },
    }),

  getReplyLogs: (start_date, end_date, page, per, filter = "") =>
    httpV2.get("/reports/reply", {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getSmartLockLogs: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/smart_lock_logs", {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getDestinations: (start_date, end_date, page, per) =>
    httpV2.get("/reports/destinations", {
      params: {
        start_date,
        end_date,
        page,
        per,
      },
    }),

  getImported: (start_date, end_date, page) =>
    httpV2.get("/reports/imported", {
      params: {
        start_date,
        end_date,
        page,
      },
    }),

  getAutomated: (type, start_date, end_date, page, per, filter) =>
    httpV2.get(`/reports/automated/${type}`, {
      params: {
        start_date,
        end_date,
        page,
        per,
        filter,
      },
    }),

  getHistory: (start_date, end_date, page, per, filter) =>
    httpV2.get("/reports/history", {
      params: {
        start_date,
        end_date,
        filter,
        page,
        per,
      },
    }),

  getRental: (start_date, end_date, page, per) =>
    httpV2.get("/reports/rentals", {
      params: {
        start_date,
        end_date,
        page,
        per,
      },
    }),

  getMacros: (opts = {}) => {
    const { page = 0, per = 20, search = "", fields = "" } = opts || {};

    return httpV2.get("/reports/macros", {
      params: {
        page,
        per,
        search: (search || "").trim(),
        fields: fields || "",
      },
    });
  },

  getExtras: (start_date, end_date, page, per) =>
    httpV2.get("/reports/extras", {
      params: {
        start_date,
        end_date,
        page,
        per,
      },
    }),

  getOrderDetails: (start_date, end_date, page, per) =>
    httpV2.get("/reports/order_details", {
      params: {
        start_date,
        end_date,
        page,
        per,
      },
    }),

  getIncomeByItem: (start_date, end_date, page, per) =>
    httpV2.get("/reports/income_by_item", {
      params: {
        start_date,
        end_date,
        page,
        per,
      },
    }),
    
  getBookingSourceMapping: (page, per) =>
    httpV2.get("/reports/booking_source_mapping", {
      params: {
        page,
        per,
      },
    }),

  searchAuditReservations: (date, name) =>
    httpV2.get("/reports/audit_reservations", {
      params: {
        date,
        name,
      },
    }),

  getMessageAudit: (guest_reservation_id) =>
    httpV2.get("/reports/message_audit", {
      params: {
        guest_reservation_id,
      },
    }),
};

export default ReportsService;
